import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

import { SimpleDialogComponent, SimpleDialogOptions } from 'app/components/simple-dialog.component';
import { LexXiWarningPopupComponent } from 'app/components/xi-components/lex-xi-warning-popup/lex-xi-warning-popup.component';
import { EnableClassTelemetry } from 'app/services/otel.service';

export { MatDialogRef, MAT_DIALOG_DATA };

@EnableClassTelemetry()
@Injectable()
export class DialogService {
  constructor(private matDialog: MatDialog) {}

  public showDialog<T, R = any>(
    component: ComponentType<T>,
    data?: R,
    options: MatDialogConfig = {},
    hasBackdrop = true,
    closeOnEsc?: boolean
  ): MatDialogRef<T> {
    const config = Object.assign(
      {
        data,
        hasBackdrop,
      } as MatDialogConfig,
      options
    );

    const matDialogRef = this.matDialog.open(component, config);

    if (closeOnEsc) {
      matDialogRef.keydownEvents().subscribe((event) => {
        if (event.key === 'Escape') {
          matDialogRef.close();
        }
      });
    }

    return matDialogRef;
  }

  public showDemoModeDialog(): void {
    this.showSimpleDialog({
      title: 'Demo Mode',
      content:
        'You are currently logged into a read-only demo. Please contact Lexalytics Sales for more information.',
    });
  }

  public showSimpleDialog(
    data: SimpleDialogOptions,
    options: MatDialogConfig = {}
  ): MatDialogRef<SimpleDialogComponent> {
    return this.showDialog<SimpleDialogComponent, SimpleDialogOptions>(
      SimpleDialogComponent,
      data,
      { ...options }
    );
  }

  public showWarningPopup(data: any) {
    // Hide matDialog container (using XI Warning Popup)
    const dimensions: MatDialogConfig = {
      position: { top: '-50px' },
      width: '0',
      height: '0',
      hasBackdrop: false,
    };
    return this.showDialog<LexXiWarningPopupComponent>(LexXiWarningPopupComponent, data, {
      ...dimensions,
    });
  }
}
